import { HttpClient } from "@angular/common/http";
import { Component, OnInit, ViewChild } from "@angular/core";
import { IonicPage } from "ionic-angular";
import { NavigationService } from "navigation/navigation.service";

@IonicPage({
  name: "terms-conditions",
  segment: "terms-conditions",
})
@Component({
  selector: "terms-conditions",
  templateUrl: "./terms-conditions.html",
})
export class TermsConditions implements OnInit {
  termsConditions: string;

  @ViewChild("myScroll") myScroll;

  constructor(public navSvc: NavigationService, private http: HttpClient) {}

  ionViewCanEnter() {
    return true;
  }

  ngOnInit() {
    this.readTermsConditions().subscribe(
      (contenido: string) => {
        this.termsConditions = contenido;
      },
      // CO-3348: there was no error callback, so a failed fetch of the terms
      // asset (renamed file, bad deploy, offline) was rethrown as an UNHANDLED
      // observable error. The screen still painted — termsConditions simply
      // stayed undefined — so this is a robustness fix rather than a
      // user-visible bug: it turns an unhandled throw into a logged, contained
      // failure. Handled explicitly rather than swallowed silently, because a
      // blank terms page is something an operator should be able to see a
      // reason for.
      (error: any) => {
        console.error("Failed to load the terms and conditions asset.", error);
      }
    );
  }

  public backLogin(): void {
    this.navSvc.goToInternalPage("sign-in-page", { replaceUrl: true });
  }

  readTermsConditions() {
    return this.http.get("assets/terms_conditions/terms_conditions.txt", {
      responseType: "text",
    });
  }

  /**
   * In-page anchor scrolling for the injected terms HTML.
   *
   * ⚠️ CO-3348 — THIS HANDLER IS CURRENTLY UNREACHABLE. It fires on every click
   * in the terms body, but the only classes it acts on are `link-choices-about`
   * and `link-changes-to-our`, and the destinations `id-choices-about-how-we` /
   * `id-changes-to-our`. NONE of those four strings appears anywhere in
   * assets/terms_conditions/terms_conditions.txt — in the repo or as deployed.
   * The asset's 14 anchors all carry `class="link-color"` and are ordinary
   * external/mailto links.
   *
   * So the scroll logic below cannot execute: every click falls through the
   * loop without matching. It is left in place rather than deleted because the
   * asset is content that may legitimately regain those anchors, and deleting
   * live-looking code under a coverage ticket is the wrong call — but nothing
   * currently exercises it, and a BDD scenario pins the mismatch so it is
   * visible rather than assumed to work.
   *
   * A second limitation, if it is ever revived: it reads `event.target`, so a
   * click on a child element INSIDE an anchor (a <span>, <strong>, …) does not
   * match. It would need `closest("a")`.
   */
  handleDynamicClick(event: MouseEvent) {
    const element = event.target as HTMLElement;
    let classMap = {
      "link-choices-about": "id-choices-about-how-we",
      "link-changes-to-our": "id-changes-to-our",
    };
    for (let linkClass in classMap) {
      if (
        element.tagName.toLowerCase() === "a" &&
        element.classList.contains(linkClass)
      ) {
        const destinationElements = document.getElementsByClassName(
          classMap[linkClass]
        );
        if (destinationElements.length > 0) {
          const destinationElement = destinationElements[0] as HTMLElement;
          const destinationY = destinationElement.offsetTop;

          if (
            this.myScroll &&
            this.myScroll._scrollContent &&
            this.myScroll._scrollContent.nativeElement
          ) {
            this.myScroll._scrollContent.nativeElement.scrollTop =
              destinationY - 20;
          } else {
            console.error("Scroll container is not available.");
          }
        } else {
          console.error("Destination element not found.");
        }
        break;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/common/cognito/terms-conditions/terms-conditions.ts